/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* functieedit.ts
* 04-05-2020 - Jelmer Jellema - Spin in het Web B.V.
*/

import {Component} from '@angular/core';
import {Editscherm} from '../../abstracts/editscherm';

@Component({
  selector: 'functie-edit',
  templateUrl: './functieedit.html'
})
export class Functieedit extends Editscherm {

  _starttitle = 'Functie';
  icon = 'fas fa-clipboard-list';
  table = 'functie';
  fixedSize = true;
  fixedWidth = 400;
  fixedHeight = 580;
  defaultRecord = {
    kleur: '#000000'
  };

  //constructor ivm injection
  constructor() {
    super('debug');
  }

  /**
   * Dynamische titel
   */
  get title(): string {
    return this.isNieuw ? 'Nieuwe functie' : `${this.orig.naam} - Bewerk functie`;
  }

  //recordbeschrijving
  get recordBeschrijving(): string {
    return this.isNieuw ? 'een nieuwe functie' : `'${this.orig.naam}'`;
  }
}
